import { Injectable } from '@angular/core';

@Injectable()
export class MsisdnHelperService {

  public unformatMsisdn(formattedMsisdn: string, withPrefix = false): string {
    let unformattedNumber = formattedMsisdn;
    if (formattedMsisdn.charAt(0) === '+') {
      const startNumber = withPrefix ? 1 : 4;
      unformattedNumber = formattedMsisdn.substring(startNumber);
    }

    return unformattedNumber.replace(/\s/g, '');
  }
}
